module.exports = __webpack_public_path__ + "static/bg-min-e4aa8f4988d8f286dc62ef2ca0326d07.jpg";